import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";

import {Observable} from "rxjs";
import {Estado} from "../models/estado";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {ConfiguracaoGrupoPlano} from "../models/configuracao-grupo-plano";
import {ConfiguracaoPlano} from "../models/configuracao-plano";
import {Meta} from "../models/meta";
import {Objetivo} from "../models/objetivo";
import {AcaoEstrategica} from "../models/acao-estrategica";
import {Avaliacao} from "../models/avaliacao";
import {OutraDefinicao} from "../models/outra-definicao";
import {Arquivo} from "../models/arquivo";
import {Plano} from "../models/plano";

@Injectable({
    providedIn: 'root'
})
export class ArquivoService {

    private api_url = environment.api_url + "/arquivo";

    constructor(private http: HttpClient) {

    }

    uploadFile(formData): Observable<any> {
        let url: string = this.api_url + "/upload";
        return this.http.post(url, formData);
    }

    uploadFileUsuario(formData): Observable<any> {
        let url: string = this.api_url + "/uploadFile"
        return this.http.post(url, formData);
    }

    listAll(cod_plano): Observable<any> {
        let url: string = this.api_url + "/listArquivos/" + cod_plano;
        return this.http.get(url).pipe(map((res: any) => {
            return res.files;
        }));
    }

    listArquivosUsuario(cod_usuario): Observable<any> {
        let url: string = this.api_url + "/listArquivosUsuario/" + cod_usuario;
        return this.http.get(url).pipe(map((res: any) => {
            return res.files;
        }));
    }

    removeArquivo(formData): Observable<any> {
        let url: string = this.api_url + "/delete";
        return this.http.post(url, formData).pipe(map((res: any) => {
            return res;
        }));
    }

    downloadArquivo(cod_arquivo): void {
        let url: string = this.api_url + "/download/" + cod_arquivo;
        window.open(url);
    }

    alteraDescricao(formData): Observable<any> {
        let url: string = this.api_url + "/upload";
        return this.http.post(url, formData).pipe(map((res: any) => {
            return res;
        }));

    }
}
